import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

export default function AdminPasswordModal({
  openReset,
  password,
  setOpenReset,
  showdata,
}) {
  const handleCopy = () => {
    navigator.clipboard.writeText(password);
    alert("Password copied to clipboard!");
  };

  return (
    <div>
      <Modal open={openReset} onClose={() => setOpenReset(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            width: 350,
          }}
        >
          <Typography variant="h5" fontWeight="bold">
            Admin Name: {showdata[0]?.name || "Admin"}
          </Typography>
          <Typography variant="body1" color="text.secondary" mt={1}>
            Role: {showdata[0]?.entity || "admin"}
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mt: 3,
              bgcolor: "#f1f3f4",
              p: 1,
              borderRadius: 1,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                flexGrow: 1,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {password || "Loading..."}
            </Typography>
            <Tooltip title="Copy Password">
              <IconButton onClick={handleCopy}>
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
          </Box>

          <Button
            variant="outlined"
            color="error"
            sx={{ mt: 3 }}
            onClick={() => setOpenReset(false)}
          >
            Close
          </Button>
        </Box>
      </Modal>
    </div>
  );
}
